/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Member_DetailsInputs */

const en_claims_member_details = /** @type {(inputs: Claims_Member_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member Details`)
};

const fr_claims_member_details = /** @type {(inputs: Claims_Member_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails du membre`)
};

/**
* | output |
* | --- |
* | "Member Details" |
*
* @param {Claims_Member_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_member_details = /** @type {((inputs?: Claims_Member_DetailsInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Member_DetailsInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_member_details(inputs)
	return fr_claims_member_details(inputs)
});